import { UsersApiFactory } from 'client/identity'
import axios from 'axios'
import type {
  ClientAvailableClient,
  CommandsCreateDocumentCenterUserRequest,
  Configuration,
  QueriesDocumentCenterUser,
  TransferObjectsResponseDTO,
  UserAvailableUser,
  UserCreateUserResponse,
} from 'client/identity'
import type { AxiosError, AxiosPromise, AxiosResponse } from 'axios'
import type { EnumerationsSortDirection } from 'client'
import { getApiEndpoint } from '~/helpers/api'
import { HNRV2, fileNetworkRequest } from '~/helpers'

export function useUsersApiService(configuration?: Configuration) {
  const axiosInstance = axios.create({
    withCredentials: true,
  })

  const usersApi = UsersApiFactory(
    configuration,
    getApiEndpoint(window.__env?.IDENTITY_PORT),
    axiosInstance
  )

  // Get Avatar and setAvatar are the only methods that are hooked up.

  const getAvatar = (): Promise<
    AxiosResponse<File> | AxiosError<File | void>
  > => {
    return fileNetworkRequest({
      fn: () => usersApi.apiIdentityUsersAvatarGet(),
      shouldErrorRedirect: false,
      axiosInstance,
    })
  }

  const setAvatar = (
    newAvatar: Blob
  ): Promise<
    | TransferObjectsResponseDTO
    | AxiosError<void | TransferObjectsResponseDTO, any>
  > => {
    const file = new File([newAvatar], 'avatar.png')
    return HNRV2({
      fn: () => usersApi.apiIdentityUsersAvatarPost(file),
    })
  }

  // const getClients = (
  //   searchTerm?: string,
  //   sortDirection?: EnumerationsSortDirection
  // ): AxiosPromise<Array<ClientAvailableClient>> => {
  //   return usersApi.apiIdentityUsersClientsGet(searchTerm, sortDirection)
  // }

  const getConsultants = (): Promise<Array<UserAvailableUser> | AxiosError> => {
    return HNRV2({
      fn: () => usersApi.apiIdentityUsersConsultantsGet(),
    })
  }

  // const getDocumentCenterUsers = (): AxiosPromise<
  //   Array<QueriesDocumentCenterUser>
  // > => {
  //   return usersApi.apiIdentityUsersDocumentCenterGet()
  // }

  // const switchClient = (clientID: string): AxiosPromise<File> => {
  //   return usersApi.apiIdentityUsersSwitchClientClientIDPut(clientID)
  // }

  // const createUser = (
  //   commandsCreateDocumentCenterUserRequest?: CommandsCreateDocumentCenterUserRequest
  // ): AxiosPromise<UserCreateUserResponse> => {
  //   return usersApi.apiIdentityUsersUserPost(
  //     commandsCreateDocumentCenterUserRequest
  //   )
  // }

  return {
    axiosInstance,
    getAvatar,
    setAvatar,
    // getClients,
    getConsultants,
    // getDocumentCenterUsers,
    // switchClient,
    // createUser,
  }
}
